<div
  class="commission-table-add-container"
  [formGroup]="commissionTableForm"
  fxLayout="column"
  fxLayoutGap="15px"
>

  <div fxLayout="row" fxLayoutGap="15px">

    <button
      (click)="save()"
      [class.spinner]="processingRequest"
      [disabled]="processingRequest || !commissionTableForm.valid"
      mat-stroked-button
      color="primary"
    >
      <mat-icon>save</mat-icon>
      <span> Zapisz</span>
    </button>

    <button
      (click)="cancel()"
      mat-stroked-button
      color="warn"
    >
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span>
    </button>

  </div>

  <div
    fxLayout="row"
    fxLayout.lt-lg="column"
    fxLayoutGap="15px"
  >

    <div fxFlex="50" fxFlex.lt-lg="100">
      <mat-card>
        <h3>Dane tabeli prowizyjnej</h3>
        <div fxLayout="row" fxLayoutGap="15px">

          <mat-form-field fxFlex="70">
            <mat-label>Nazwa</mat-label>

            <input
              matInput
              placeholder="Standard prowizyjny 2026.1"
              formControlName="name"
              required
            >

            <mat-error
              *ngIf="nameControl.hasError('required')"
            >
              To pole jest wymagane
            </mat-error>

            <mat-error
              *ngIf="nameControl.hasError('backendError')"
            >
              {{ nameControl.getError('backendError') }}
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="30">
            <mat-label>Nazwa skrócona</mat-label>

            <input
              matInput
              placeholder="2026.1"
              formControlName="shortName"
              required
            >

            <mat-error
              *ngIf="shortNameControl.hasError('required')"
            >
              To pole jest wymagane
            </mat-error>

            <mat-error
              *ngIf="shortNameControl.hasError('backendError')"
            >
              {{ shortNameControl.getError('backendError') }}
            </mat-error>
          </mat-form-field>

        </div>
        <div fxLayout="row">

          <mat-form-field
            fxFlex="100"
            *ngIf="!commissionTableObject"
          >
            <mat-label>Tabela źródłowa</mat-label>

            <mat-select formControlName="sourceTable">

              <mat-option [value]="null">
                Brak
              </mat-option>

              <mat-option
                *ngFor="let table of sourceTables"
                [value]="table.uuid"
              >
                {{ table.shortName }}
                -
                {{ table.name }}
              </mat-option>

            </mat-select>

            <mat-hint>
              Opcjonalnie skopiuj stawki z istniejącej tabeli
            </mat-hint>

          </mat-form-field>

          <app-detail
            *ngIf=" commissionTableObject  && commissionTableObject.sourceTable"
            fxFlex="100"
            header="Tabela źródłowa"
            [value]="commissionTableObject.sourceTable.shortName  + ' - ' + commissionTableObject.sourceTable.name"
          ></app-detail>

        </div>
        <div fxLayout="row" fxLayoutGap="15px">

          <app-datepicker
            fxFlex="50"
            label="Obowiązuje od"
            placeholder="2026-09-01"
            [required]="true"
            [control]="validFromControl"
          ></app-datepicker>

          <app-datepicker
            fxFlex="50"
            label="Obowiązuje do"
            placeholder="2026-12-31"
            [required]="false"
            [control]="validToControl"
            [minDate]="validFromControl.value || todayDate"
          ></app-datepicker>

        </div>
      </mat-card>

    </div>

    <div fxFlex="50" fxFlex.lt-lg="100">

      <mat-card>

        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <h3>Przypisania</h3>

          <button
            type="button"
            (click)="addAssignment()"
            mat-stroked-button
            color="accent"
          >
            <mat-icon>add</mat-icon>
            Dodaj przypisanie
          </button>
        </div>

        <div
          formArrayName="assignments"
          fxLayout="column"
          fxLayoutGap="10px"
        >

          <div
            *ngFor="
              let assignment of assignments.controls;
              index as i
            "
            [formGroupName]="i"
            fxLayout="row"
            fxLayoutGap="15px"
            fxLayoutAlign="start center"
          >

            <app-dict
              fxFlex
              label="Firma"
              dictType="company"
              [required]="true"
              [control]="$any(assignment.get('company'))"
            ></app-dict>

            <app-dict
              fxFlex
              label="Rodzaj umowy Partnera"
              dictType="contract_type"
              [required]="true"
              [control]="$any(assignment.get('contractType'))"
            ></app-dict>

            <button
              type="button"
              mat-icon-button
              color="warn"
              matTooltip="Usuń"
              [disabled]="assignments.length === 1"
              (click)="removeAssignment(i)"
            >
              <mat-icon>delete</mat-icon>
            </button>

          </div>

        </div>

        <mat-error
          *ngIf="
            commissionTableForm
              .get('assignments')
              .hasError('backendError')
          "
        >
          {{
            commissionTableForm
              .get('assignments')
              .getError('backendError')
          }}
        </mat-error>

      </mat-card>

    </div>

  </div>

</div>
